import React from "react";
import { string, shape, object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { filterStoriesByForum } from "../../utils/forum-filter";
import { collectionToStories } from "@quintype/components";
import { filterStoriesByTemplate } from "../../utils/story-utils";

import { CategoryLandingPage } from "./category-page";
import { ResearchHubPage } from "./research-hub";
import LoadingIndicatorComponent from "../atoms/loading-indicator";
import LeadershipInFocusPage from "./leadership-In-Focus/LeadershipInFocus";

import "./research-hub.m.css";

const SectionPage = (props) => {
  const member = useSelector((state) => get(state, ["member"], null));
  const subscriberMetadata = useSelector((state) => get(state, ["subscriberMetadata"], null));
  const isAuthInitializing = useSelector((state) => get(state, ["isAuthInitializing"], false));

  // Show loading while auth is initializing or waiting for subscriber metadata for logged-in users
  if (isAuthInitializing || (member && !subscriberMetadata)) {
    return <LoadingIndicatorComponent />;
  }

  // Get and filter stories from collection
  let stories = [];
  if (props.data.collection && props.data.collection.items) {
    // Get all stories from collection
    const allStories = collectionToStories(props.data.collection);

    // Filter out stories with specific story templates
    const templateFilteredStories = filterStoriesByTemplate(allStories);

    // Apply forum-based filtering to the template-filtered stories
    stories = filterStoriesByForum(
      templateFilteredStories.map(story => ({ type: "story", story })),
      member,
      subscriberMetadata
    ).map(wrapper => wrapper.story);
  }

  const noStoriesFound = "No stories found";

  if (props?.data?.section?.slug === "leadership-in-focus") {
    return (
      <LeadershipInFocusPage {...props} />
    );
  }

  const isLeadershipInFocus = props?.data?.section?.slug === "leadership-in-focus";

  if (stories.length === 0 && (props.pageType === "collection-page" || isLeadershipInFocus)) {
    return (
      <div className="container">
        <h1 styleName="research-hub-no-content">{noStoriesFound}</h1>
      </div>
    );
  }

  const childCollections = (get(props, ["data", "collection", "items"]) || []).filter(
    (item) => item.type === "collection" && item.items.length > 0
  );

  // If this section/collection has nested collections (collection of collections), show ResearchHub page layout
  if (childCollections.length > 0) {
    return (
      <ResearchHubPage {...props} />
    );
  }

  // Use CategoryLandingPage layout for all collection of stories
  return <CategoryLandingPage {...props} />;
};

SectionPage.propTypes = {
  pageType: string,
  data: shape({
    collection: object,
    section: string,
  }),
};

export { SectionPage };